import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import { translate } from 'react-i18next'
import { compose } from 'recompose'
import routes from '../../routes/root/routes'
import styles from './appWrapperComponent.scss'
import SmartLoginModal from '../../containers/loginModal/loginModalContainer'
import SmartRegisterModal from '../../containers/registerModal/registerModalContainer'
import LoginForm from '../../forms/login/loginForm'
import SmartRegistrationForm from '../../containers/registrationFormWrapper/registrationFormWrapperContainer'
import SmartResetPwModal from '../../containers/resetPwModal/resetPwModalContainer'
import SmartModalNotification from '../../containers/modalNotification/modalNotificationContainer'
import SmartNotification from '../../containers/notification/notificationContainer'
import ResetPwForm from '../../forms/resetPw/resetPwForm'
import SmartTosDocsModal from '../../containers/tosDocsModal/tosDocsModalContainer'
import SmartShortUrlModal from '../../containers/shortUrlModal/shortUrlModalContainer'
import SmartShortUrl from '../../containers/shortUrl/shortUrlContainer'
import TosForm from '../../forms/tos/tosForm'
import SiteFooter from '../footer/footerComponent'
import PropTypes from 'prop-types'
import axios from '../../redux/axios'

// export function AppWrapper (props) {

export class AppWrapper extends React.Component {
  constructor () {
    super()
    this.views = {}
  }

  componentDidMount () {
    axios.get('/environment')
      .then(res => {
        /*
        // To collect end-user usage analytics about your application,
        // insert the following script into each page you want to track.
        // Place this code immediately before the closing </head> tag,
        // and before any other scripts. Your first data will appear
        // automatically in just a few seconds.
        */
        /* eslint-disable no-unused-expressions, one-var, quotes, no-sequences, yoda */
        var appInsights = window.appInsights || (function (a) {
          function b (a) { c[a] = function () { var b = arguments; c.queue.push(function () { c[a].apply(c, b) }) } } var c = { config: a }, d = document, e = window; setTimeout(function () { var b = d.createElement("script"); b.src = a.url || "https://az416426.vo.msecnd.net/scripts/a/ai.0.js", d.getElementsByTagName("script")[0].parentNode.appendChild(b) }); try { c.cookie = d.cookie } catch (a) { } c.queue = []; for (var f = ["Event", "Exception", "Metric", "PageView", "Trace", "Dependency"]; f.length;)b("track" + f.pop()); if (b("setAuthenticatedUserContext"), b("clearAuthenticatedUserContext"), b("startTrackEvent"), b("stopTrackEvent"), b("startTrackPage"), b("stopTrackPage"), b("flush"), !a.disableExceptionTracking) { f = "onerror", b("_" + f); var g = e[f]; e[f] = function (a, b, d, e, h) { var i = g && g(a, b, d, e, h); return !0 !== i && c["_" + f](a, b, d, e, h), i } } return c
        }({
          instrumentationKey: res.data.appInsightsInstrumentationKey
        }))

        window.appInsights = appInsights, appInsights.queue && 0 === appInsights.queue.length && appInsights.trackPageView()
        /* eslint-enable no-unused-expressions, one-var, quotes, no-sequences, yoda */
      }).catch(err => {
        const log = console.error || console.log
        log('Telemetry Setup FAILED', err)
      })
  }

  loadView (fileName) {
    if (this.views[fileName]) {
      return this.views[fileName]
    }
    new Promise(resolve => {
      switch (fileName) {
        case 'gradNav':
          require.ensure(
            ['../../containers/gradPlannerNav/gradPlannerNavContainer'],
            require => {
              resolve(
                require('../../containers/gradPlannerNav/gradPlannerNavContainer')
                  .default
              )
            }
          )
          break
        default:
          require.ensure(
            ['../../containers/gradPlannerNav/gradPlannerNavContainer'],
            require => {
              resolve(
                require('../../containers/siteNav/siteNavContainer').default
              )
            }
          )
          break
      }
    })
      .then(View => {
        this.views[fileName] = <View />
      })
      .then(() => this.forceUpdate())
      .catch(err => {
        console.error(err)
        throw new Error(err)
      })

    return <div />
  }
  render () {
    const { t } = this.props

    return (
      <div
        className={[
          styles.app,
          this.props.location.pathname === '/gradplanner' &&
            styles.gradPlannerBackground
        ].join(' ')}
      >
        <a id='skippy' className={styles.srOnly} href='#content'>
          <div className={styles.skipContainer}>Skip to Content</div>
        </a>
        <Switch>
          <Route
            path={routes.gradPlanner}
            component={() => this.loadView('gradNav')}
          />
          <Route component={() => this.loadView('siteNav')} />
        </Switch>
        {this.props.children}

        <SiteFooter />
        <SmartLoginModal contentLabel={t('form:login')}>
          <LoginForm />
        </SmartLoginModal>
        <SmartRegisterModal contentLabel={t('form:register')}>
          <SmartRegistrationForm />
        </SmartRegisterModal>
        <SmartResetPwModal contentLabel={t('form:resetPassword')}>
          <ResetPwForm />
        </SmartResetPwModal>
        <SmartModalNotification contentLabel={t('form:notification')}>
          <SmartNotification />
        </SmartModalNotification>
        <SmartShortUrlModal contentLabel={t('url:shortUrl')}>
          <SmartShortUrl />
        </SmartShortUrlModal>
        <SmartTosDocsModal
          role='alertdialog'
          contentLabel={t('form:register')}
          shouldCloseOnOverlayClick={false}
        >
          <TosForm />
        </SmartTosDocsModal>
      </div>
    )
  }
}
AppWrapper.propTypes = {
  children: PropTypes.any.isRequired,
  location: PropTypes.any,
  t: PropTypes.func.isRequired
}
export default compose(translate(), withRouter)(AppWrapper)



// WEBPACK FOOTER //
// ./src/components/appWrapper/appWrapperComponent.js